export default __webpack_public_path__ + "static/media/sexxyy.8e18f545.png";